import { gql } from '@common/hooks';

export const AUTHENTICATE_WORKS_USER_PASSWORD_MUTATION = gql`
  mutation AuthenticateWorksUserPassword(
    $input: AuthenticateWorksUserPasswordInput!
  ) {
    authenticateWorksUserPassword(input: $input) {
      preAuthToken
      internalTrustedUser
      memberships {
        id
        role
        entityName
        entityCode
      }
    }
  }
`;

export const SIGN_IN_WORKS_USER_MUTATION = gql`
  mutation SignInWorksUser($input: SignInWorksUserInput!) {
    signInWorksUser(input: $input) {
      worksUser {
        id
        name
      }
      worksMembership {
        id
        name
        entityType
        saveLastVisitedPage
        roleName
        entity: entityProvider {
          ... on Organization {
            id
            name
          }
          ... on Supplier {
            id
            name
          }
        }
      }
      identityToken
    }
  }
`;
